import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from '../components/Homepage';
import MobileHomepage from '../components/MobileHomepage';
import LockerPage from '../pages/LockerPage';
// CHANGED: add LockerShowcasePage route for the new Showcase builder
import LockerShowcasePage from '../pages/LockerShowcasePage';
import FAQPage from '../pages/FAQPage';
import TermsPage from '../pages/TermsPage';
import PrivacyPage from '../pages/PrivacyPage';
import ReturnRefundPage from '../pages/ReturnRefundPage';
import AboutPage from '../pages/AboutPage';
import OnlineGachaponPage from '../pages/OnlineGachaponPage';
// CHANGED: add AnimeVegasPage route for Anime Vegas landing
import AnimeVegasPage from '../pages/AnimeVegasPage';
import AuthActionPage from '../pages/AuthActionPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import TutorialPage from '../pages/TutorialPage';

// CHANGED: Preserve hash/search when redirecting unknown paths, so auth redirect (#id_token=...) is not stripped
const RedirectToHome = () => {
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: '/', hash: location.hash, search: location.search }}
      replace
    />
  );
};

const AppRoutes = ({ isMobile = false }) => {
  return (
    <Routes>
      <Route
        path="/"
        element={(
          isMobile ? <MobileHomepage /> : <HomePage />
        )}
      />
      <Route
        path="/home-ponpon2025"
        element={(
          isMobile ? <MobileHomepage /> : <HomePage />
        )}
      />
      <Route path="/locker" element={<LockerPage />} />
      {/* CHANGED: add dedicated route for Locker Showcase builder */}
      <Route path="/locker/showcase" element={<LockerShowcasePage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/return-refund" element={<ReturnRefundPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/online-gachapon" element={<OnlineGachaponPage />} />
      {/* CHANGED: Add Anime Vegas landing page */}
      <Route path="/animevegas" element={<AnimeVegasPage />} />
      {/* CHANGED: Add unified auth action handler for email verification and password reset */}
      <Route path="/auth/action" element={<AuthActionPage />} />
      {/* CHANGED: Add password reset page */}
      <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
      {/* CHANGED: Add tutorial page for onboarding */}
      <Route path="/tutorial" element={<TutorialPage />} />
      <Route path="*" element={<RedirectToHome />} />
    </Routes>
  );
};

export default AppRoutes;
